<div *ngIf="this.authService.loggedIn">
  <div class="modal-header">
    <h4>{{ 'shareToTeams.title' | translate }}</h4>
    <button
      [attr.aria-label]="'common.close' | translate"
      class="close-modal-btn text"
      (click)="modalRef.hide()"
    >
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <form class="share-form" [formGroup]="shareForm" (ngSubmit)="onSubmit()">
    <div class="modal-body">
      <div class="form-group">
        <span
          [ngClass]="{ visible: shareForm.controls['team'].value }"
          class="label"
          >{{ 'shareToTeams.team' | translate }}</span
        >
        <ngx-select
          [items]="teams"
          formControlName="team"
          optionTextField="displayName"
          optionValueField="id"
          [placeholder]="'shareToTeams.team' | translate"
        >
        </ngx-select>
      </div>

      <div class="form-group">
        <span
          [ngClass]="{ visible: shareForm.controls['channel'].value }"
          class="label"
          >{{ 'shareToTeams.channel' | translate }}</span
        >
        <ngx-select
          [items]="channels"
          formControlName="channel"
          optionTextField="displayName"
          optionValueField="id"
          [placeholder]="'shareToTeams.channel' | translate"
        >
        </ngx-select>
      </div>

      <div class="form-group">
        <textarea
          class="message"
          [placeholder]="'shareToTeams.message' | translate"
          formControlName="message"
        ></textarea>
        <span
          [ngClass]="{ visible: shareForm.controls['message'].value }"
          class="label"
          >{{ 'shareToTeams.message' | translate }}</span
        >
      </div>
    </div>

    <div class="modal-footer">
      <div class="buttons-right-container">
        <button class="text" (click)="modalRef.hide()" type="button">
          {{ 'common.cancel' | translate }}
        </button>
        <button [disabled]="shareForm.invalid" type="submit">{{ 'common.send' | translate }}</button>
      </div>
    </div>
    <ngx-spinner
      name="share-spinner"
      type="ball-clip-rotate"
      bdColor="rgba(255,255,255,0.6)"
      color="rgba(37,52,247,.54)"
      size="medium"
      [fullScreen]="false"
    >
    </ngx-spinner>
  </form>
  <div class="backdrop"></div>
</div>
